import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PHBHPFeaturePackageConsumptionService } from "./../ph-bhp-feature-package-consumption.service";
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { DatePipe } from '@angular/common';
import { ConsumptionPeriod } from './../Models/ConsumptionPeriod';
import { ConsumptionConfig } from './../Models/ConsumptionConfig';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-past-consumption',
  templateUrl: './ph-bhp-past-consumption.component.html',
  styleUrls: ['./ph-bhp-past-consumption.component.css'],
  providers: [DatePipe]
})
export class PhBhpPastConsumptionComponent implements OnInit, OnDestroy {
  consumptionId: number;
  searchText
  consumptionConfigDetail: any = [];
  consumptionPeriodDetail: Array<ConsumptionPeriod> = [];
  periodName: string;
  haiEnabled: boolean = false;
  timeflag = '';
  timeLine = [];
  subscription: Subscription;
  langSubscription: Subscription;
  unit

  emitData: any = {
    key: ''
  }
  translationKeys: typeof TranslationKeys = TranslationKeys;
  consumptionYearConfiguration: any;

  constructor(
    public appConfig: AppConfig,
    private router: Router,
    private service: PHBHPFeaturePackageConsumptionService,
    private activeRouter: ActivatedRoute,
    private layoutService: PHBHPLayoutPackageService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.onInitService();
  }

  onInitService() {
    this.consumptionId = parseInt(this.activeRouter.snapshot.paramMap.get('Id'));

    if (this.layoutService.institutionID) {
      this.getConsumptionConfigById();
      this.getConsumptionPeriodByConsumptionIdList();
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((Id) => {
      this.layoutService.institutionID = Id;
      this.getConsumptionConfigById();
      this.getConsumptionPeriodByConsumptionIdList();
    });
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.reSetTime();
      this.setTimeLine(this.consumptionPeriodDetail);
    })
  }
  reSetTime() {
    this.timeflag = '';
    this.timeLine = [];
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
  onChildNavigate(event: any) {
    if (event.key === 'start') {
      this.router.navigate(['consumption/past/start']);
    }
  }
  getConsumptionConfigById() {
    this.layoutService.showLoader = true;
    this.service.getConsumptionConfigByInstitutionId(this.layoutService.institutionID).subscribe((res: any) => {
      this.consumptionConfigDetail = res;
      this.haiEnabled = this.consumptionConfigDetail.enableHAITracking;
      this.layoutService.showLoader = false;
    });
  }

  periodData(data) {
    switch (data) {
      case 'm':
        return '12 ' + this.layoutService.translateText('CONFIGURE.MONTH');
      case 'y':
        return '1 ' + this.layoutService.translateText('CONFIGURE.YEAR');
      case 'q':
        return '4 ' + this.layoutService.translateText('CONFIGURE.QUARTER');
    }
  }

  getConsumptionPeriodByConsumptionIdList() {
    if (this.layoutService.institutionID) {
      this.layoutService.showLoader;
      this.service.getConsumptionPeriodListByConsumptionId(this.layoutService.institutionID).subscribe((res: Array<ConsumptionPeriod>) => {
        this.consumptionPeriodDetail = res;
        this.layoutService.showLoader = false;
        this.setTimeLine(this.consumptionPeriodDetail)

      });
    }
  }

  //   searchTextChange(){
  //     this.consumptionPeriodDetail = this.tempSessionList.filter(word => word.departmentName.toLowerCase().includes(this.searchText.toLowerCase()) || word.wardName.toLowerCase().includes(this.searchText.toLowerCase()));
  //     this.setTimeLine(this.tempSessionList);
  //   }


  amountMeasure(year) {
    let yearConsumptionConfiguration = this.service.getConsumptionYearConfiguration(this.consumptionConfigDetail.consumptionConfigs, year)
    if (yearConsumptionConfiguration?.amountMeasured === 'u') {
      return this.layoutService.translateText('CONSUMPTION.USED.DISPLAY_TEXT');
    } else if (yearConsumptionConfiguration?.amountMeasured === 'p') {
      return this.layoutService.translateText('CONSUMPTION.PURCHASED.DISPLAY_TEXT');
    }
  }

  unitMeasure(year) {
    let yearConsumptionConfiguration = this.service.getConsumptionYearConfiguration(this.consumptionConfigDetail.consumptionConfigs, year)
    if (yearConsumptionConfiguration?.unitOfMeasure === 'l') {
      return this.layoutService.translateText('DASHBOARD.LITERS');
    } else if (yearConsumptionConfiguration?.unitOfMeasure === 'm') {
      return this.layoutService.translateText('DASHBOARD.MILLILITERS');
    }
  }

  setTimeLine(sessionList) {
    this.timeLine = [];
    sessionList.forEach((value, index) => {
      var timeflag = value.createdDateTime.split("T")[0];
      var timeData = {} as any

      if (this.timeflag == timeflag) {
        timeData.date = false
      } else {
        this.timeflag = timeflag;
        timeData.date = "";
        if (index == 0) {
          var date = new Date();
          var dateFlag = date.toISOString().split("T")[0]
          if (dateFlag == timeflag) {
            timeData.isToday = true;
          }
        }
        var lang = localStorage.getItem('selectedlanguage');
        var newDate = this.layoutService.convertUTCStingToLocalDate(value.createdDateTime);
        var latest_date = newDate.toLocaleDateString(lang, { weekday: 'long', month: "long", day: "numeric", year: "numeric" });
        timeData.date += latest_date;
      }
      timeData.createdDateTime = this.datePipe.transform(this.layoutService.convertUTCStingToLocalDate(value.createdDateTime), 'hh:mm a');
      // timeData.endDateTime = this.datePipe.transform( this.data.convertUTCStingToLocalDate(value.endDateTime), 'hh:mm a');
      this.timeLine.push(timeData);
    })
  }

  onClick(item) {
    this.router.navigate(['/consumption/new/start', item.period, item.consumptionID]);

  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }
}
